import styled from 'styled-components';
import { UnstyledButton, makeFocusRing } from '@workramp/ui';

const HEADER_PADDING = 3;

export const HeaderWrapper = styled.div`
  box-sizing: border-box;
  position: sticky;
  top: 0;
  padding-top: ${({ theme }) => theme.spacing(HEADER_PADDING)}px;
  padding-bottom: ${({ theme }) => theme.spacing(HEADER_PADDING)}px;
  background-color: ${({ theme }) => theme.colors.surface[0]};
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: ${({ theme }) => theme.spacing(HEADER_PADDING)}px;
  }
`;

export const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const AvatarButton = styled(UnstyledButton)`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: ${({ theme }) => theme.spacing(2)}px;
`;

export const SearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const SearchBarWrapper = styled.div`
  width: 100%;

  .search-bar {
    input {
      box-sizing: border-box;
      width: 100%;
      color: ${({ theme }) => theme.colors.on[900]};
      background-color: ${({ theme }) => theme.colors.secondary[50]};
      background-image: none;
      height: ${({ theme }) => theme.spacing(10)}px;
      padding-left: ${({ theme }) => theme.spacing(12)}px;
      padding-right: ${({ theme }) => theme.spacing(16)}px;
      padding-top: 0;
      padding-bottom: 0;
      border-radius: ${({ theme }) => theme.radii.xl}px;
      border: 1px solid transparent;
      outline: 1px;
      outline-color: transparent;
      font-size: ${({ theme }) => theme.typography.generateFontSize(1)}px;
      transition: ${({ theme }) =>
        `background-color ${theme.motion.duration.short}ms ease-in-out,
         border-color ${theme.motion.duration.short}ms ease-in-out,
         outline-color ${theme.motion.duration.short}ms ease-in-out,
         color ${theme.motion.duration.short}ms ease-in-out`};

      &::placeholder {
        opacity: 1;
        color: ${({ theme }) => theme.colors.on[600]};
      }

      &:hover {
        border-color: ${({ theme }) => theme.colors.on[300]};
      }

      &:focus {
        opacity: 1;
        box-shadow: none;
        ${({ theme }) => makeFocusRing(theme.colors.primary[600])}
        border-color: ${({ theme }) => theme.colors.primary[600]};
      }
    }
  }
`;

export const StyledSearchIcon = styled.div`
  position: absolute;
  left: ${({ theme }) => theme.spacing(4)}px;
  z-index: 15;
`;

export const StyledAdvancedSearch = styled.div`
  position: absolute;
  right: ${({ theme }) => theme.spacing(4)}px;
  z-index: 15;
`;

export const NavItem = styled.div`
  margin-left: ${({ theme }) => theme.spacing(4)}px;
`;
